import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { seoForPath } from "@consts";
import { blogPosts } from "../content/blog-posts";
import { applyDocumentSeo } from "../lib/document-meta";

/**
 * Sets title, description, canonical, and robots for the current route.
 * Query strings are ignored so filter variants are not indexed separately.
 */
export function PageSeo() {
  const { pathname } = useLocation();

  useEffect(() => {
    applyDocumentSeo(seoForPath(pathname, blogPosts));
  }, [pathname]);

  return null;
}
